export const ArtGalleryIcon = () => {
  return (
    <svg
      width={41}
      height={40}
      viewBox="0 0 41 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x={0.5}
        width={40}
        height={40}
        rx={10}
        fill="white"
        style={{fill: 'white', fillOpacity: 1}}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M34.8227 11.0968C34.8227 12.0748 34.3693 12.9468 33.6614 13.5143C33.523 13.6252 33.375 13.7245 33.2187 13.8106C32.8191 14.0309 32.5001 14.4149 32.5001 14.8712V25.1288C32.5001 25.5851 32.8191 25.9691 33.2187 26.1894C33.375 26.2755 33.523 26.3748 33.6614 26.4857C34.3693 27.0532 34.8227 27.9252 34.8227 28.9032C34.8227 30.6135 33.4362 32 31.7259 32C30.7479 32 29.8758 31.5467 29.3083 30.8387C29.1974 30.7004 29.0982 30.5523 29.012 30.396C28.7917 29.9964 28.4078 29.6774 27.9515 29.6774H13.0487C12.5924 29.6774 12.2084 29.9964 11.9881 30.396C11.902 30.5523 11.8027 30.7004 11.6918 30.8387C11.1243 31.5467 10.2522 32 9.27426 32C7.56394 32 6.17749 30.6135 6.17749 28.9032C6.17749 27.9252 6.63081 27.0532 7.33878 26.4857C7.47712 26.3748 7.62517 26.2755 7.78147 26.1894C8.18107 25.9691 8.50007 25.5851 8.50007 25.1288V14.8712C8.50007 14.4149 8.18107 14.0309 7.78147 13.8106C7.62517 13.7245 7.47712 13.6252 7.33878 13.5143C6.63081 12.9468 6.17749 12.0748 6.17749 11.0968C6.17749 9.38645 7.56394 8 9.27426 8C10.2522 8 11.1243 8.45332 11.6918 9.16129C11.8027 9.29963 11.902 9.44768 11.9881 9.60398C12.2084 10.0036 12.5924 10.3226 13.0487 10.3226H27.9515C28.4078 10.3226 28.7917 10.0036 29.012 9.60398C29.0982 9.44768 29.1974 9.29963 29.3083 9.16129C29.8758 8.45332 30.7479 8 31.7259 8C33.4362 8 34.8227 9.38645 34.8227 11.0968ZM10.8227 14.6452C10.8227 13.5406 11.7181 12.6452 12.8227 12.6452H28.1775C29.2821 12.6452 30.1775 13.5406 30.1775 14.6452V25.3548C30.1775 26.4594 29.2821 27.3548 28.1775 27.3548H12.8226C11.7181 27.3548 10.8227 26.4594 10.8227 25.3548V14.6452ZM21.2959 15.1422C21.0461 14.3935 19.9586 14.3934 19.7088 15.1422L18.9101 17.5368C18.7984 17.8717 18.478 18.0984 18.1166 18.0984H15.5318C14.7236 18.0984 14.3875 19.1059 15.0414 19.5686L17.1325 21.0486C17.425 21.2555 17.5473 21.6224 17.4356 21.9572L16.6369 24.3518C16.3871 25.1006 17.2669 25.7232 17.9208 25.2605L20.0119 23.7805C20.3043 23.5736 20.7003 23.5736 20.9928 23.7805L23.0839 25.2605C23.7378 25.7232 24.6176 25.1006 24.3678 24.3518L23.5691 21.9572C23.4574 21.6224 23.5797 21.2555 23.8722 21.0486L25.9633 19.5686C26.6171 19.1059 26.2811 18.0984 25.4728 18.0984H22.8881C22.5266 18.0984 22.2063 17.8717 22.0946 17.5368L21.2959 15.1422Z"
        fill="url(#paint0_linear_11041_2280)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_11041_2280"
          x1={20.5001}
          y1={8}
          x2={20.5001}
          y2={32}
          gradientUnits="userSpaceOnUse"
        >
          <stop style={{stopColor: 'black', stopOpacity: 1}} />
          <stop
            offset={1}
            stopColor="#F4FFD4"
            style={{stopColor: '#F4FFD4', stopOpacity: 1}}
          />
        </linearGradient>
      </defs>
    </svg>
  );
};
